import { createModal } from "@stainless-code/react-modal-manager";
import type { ReactNode } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

type FormModalProps = {
	title: string;
	description: string;
	form: ReactNode;
};

export const formModal = createModal<FormModalProps>(({ title, description, form, close }) => {
	return (
		<Dialog onOpenChange={(open) => !open && close()} open={true}>
			<DialogContent className="sm:max-w-150">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{description}</DialogDescription>
				</DialogHeader>

				{form}
			</DialogContent>
		</Dialog>
	);
});
